/**
 * Describes how to obtain the OpenId Connect configuration using an HTTP
 * request.
 */
export function wellKnownOidcConfigUrl(domain: string): string {
  return domain + '/.well-known/openid-configuration';
}

